import React from 'react';

import {ProfileMain, ProfileTabSeparator} from 'src/components/profile-tab-structure';
// Remove this gate import after the Account_Provisioning_History release.
import {STATSIG_GATES} from 'src/contexts/statsig-contex/constants';
import {ValidationContextProvider} from 'src/contexts/validation-context/validation-context-provider';

// Remove this gate import after the Account_Provisioning_History release.
import {useGateValue} from '@pb/kit-lib-statsig';

import {InformationSection} from './information-section';
import {AccountProvisioningHistory} from './provisioning-history/account-provisioning-history';
import {AccountUserHistoryChart} from './user-history-chart';
// Remove this legacy import after the Account_Provisioning_History release.
import {LegacyAccountUserHistoryChart} from './user-history-chart/legacy-account-user-history-chart';

type Props = {
    accountId: number,
};

export const AccountProfileTab = ({accountId}: Props) => {
    // Remove this gate check after the Account_Provisioning_History release.
    const provisioningHistoryEnabled = useGateValue(STATSIG_GATES.ACCOUNT_PROVISIONING_HISTORY);
    return (
        <ValidationContextProvider>
            <ProfileMain>
                <InformationSection accountId={accountId}/>
                <ProfileTabSeparator/>
                {/* Remove this conditional and legacy branch after the Account_Provisioning_History release. */}
                {provisioningHistoryEnabled ? (
                    <AccountUserHistoryChart accountId={accountId}/>
                ) : (
                    <LegacyAccountUserHistoryChart accountId={accountId}/>
                )}
            </ProfileMain>
            {/* Remove this conditional after the Account_Provisioning_History release; keep this section. */}
            {provisioningHistoryEnabled ? <AccountProvisioningHistory accountId={accountId}/> : null}
        </ValidationContextProvider>
    );
};
